if (!customElements.get('blog-slider')) {
  class BlogSlider extends HTMLElement {
    constructor () {
      super();
      this.actionNext     = this.querySelector('[data-carousel-action="next"]');
      this.actionPrev     = this.querySelector('[data-carousel-action="prev"]');
      this.listItems      = this.querySelectorAll('.carousel_track > *');
      this.list           = this.querySelector('.carousel_track');
      this.mqMobile       = window.matchMedia('( max-width: 767px )');
      this.index          = 0;
      this.step           = 1;
      this.minSlide       = 0;
      this.maxSlide       = this.listItems.length - 1;
      this.sliderWidth    = 0;
      this.slideWidth     = 0;

      // Touch setup
      this.touched        = false;
      this.touchStart     = 0;
      this.transformStart = 0;
      this.touchPosition  = 0;
    }

    connectedCallback() {
        this.updateConfig();

        window.addEventListener('resize', () => {
            this.updateConfig();
        });

        this.actionNext.addEventListener('click', () => {
            this.index = this.index + this.step;
            this.updateSlider();
        });
        this.actionPrev.addEventListener('click', () => {
            this.index = this.index - this.step;
            this.updateSlider();
        });
        this.addEventListener('touchstart', (event) => {
            this.touched = true;
            this.touchStart = event.touches[0].clientX;
            this.classList.add('--dragged');
        });
        this.addEventListener('touchend', (event) => {
            this.touched = false;

            this.index = Math.round(this.touchPosition / this.slideWidth);
            this.updateSlider();
            this.classList.remove('--dragged');

        });
        this.addEventListener('touchmove', (event) => {
            if (this.touched) {
                const current = this.index * this.slideWidth;
                const touchDiff = this.touchStart - event.touches[0].clientX;
                this.touchPosition = current + touchDiff;
                this.list.style.transform = `translateX(${0 - this.touchPosition}px)`;
            }
        });
        this.updateSlider();
    }

    updateConfig() {
        if (this.listItems.length === 1
            || (!this.mqMobile.matches && this.listItems.length < 4))
        {
            this.actionNext.style.display = this.actionPrev.style.display = 'none';
            this.classList.add('--no-slider');
        } else {
            this.actionNext.style.display = this.actionPrev.style.display = '';
            this.classList.remove('--no-slider');
        }

        this.sliderWidth = this.list.offsetWidth;
        this.slideWidth = this.listItems[0].offsetWidth;

        this.step = Math.round(this.sliderWidth / this.slideWidth);

        if (this.step === 1) {
            this.maxSlide = this.listItems.length - 1;
        } else {
            this.maxSlide = (Math.ceil(this.listItems.length / this.step) - 1) * this.step;
        }
    }

    updateSlider() {
        if (this.index < this.minSlide) this.index = this.minSlide;
        if (this.index > this.maxSlide) this.index = this.maxSlide;

        this.list.style.transform = `translateX(${0 - (this.index * this.slideWidth)}px)`;
    }
  }
  customElements.define('blog-slider', BlogSlider);
}